import { useState } from 'react';
import Formatters from 'formatters/_Formatter';
import Highlight from 'components/Highlight';
import './HistoryAccordion.css';

function HistoryAccordion({ history, columns, dataSet, dataSource, propertyData, searchString }) {
	const [isExpanded, setIsExpanded] = useState(false);

	if (!history || history.length === 0) {
		return null;
	}

	const toggleExpanded = () => {
		setIsExpanded(!isExpanded);
	};

	return (
		<>
			<tr className="history-toggle-row">
				<td colSpan={columns.length + 1} className="history-toggle-cell">
					<button
						className="btn btn-link history-toggle-button"
						onClick={toggleExpanded}
						type="button"
					>
						<i className={`bi ${isExpanded ? 'bi-chevron-down' : 'bi-chevron-right'}`} />
						<span className="history-toggle-text">
							{isExpanded ? 'Hide' : 'Show'} {history.length} previous {history.length === 1 ? 'version' : 'versions'}
						</span>
					</button>
				</td>
			</tr>
			{isExpanded && history.map((historyRow, idx) => (
				<tr key={`history-${historyRow.id || idx}`} className="history-row">
					<td className="data-table-buttons-cell">
						<div className="data-table-buttons-wrapper">
							{/* History rows don't have action buttons */}
						</div>
					</td>
					{columns.map((col, j) => {
						let rawContent = historyRow[col.key] || historyRow[col.altKey];
						let cellContent = rawContent || '-';

						// Format dates if it's the created_at column
						if (col.key === 'created_at' && rawContent) {
							const date = new Date(rawContent);
							cellContent = date.toLocaleDateString('en-US', {
								year: 'numeric',
								month: '2-digit',
								day: '2-digit'
							});
						}

						if (col.formatter) {
							let Formatter = Formatters[col.formatter];
							if (Formatter && rawContent) {
								cellContent = <Formatter
									text={rawContent}
									format={col.format}
									rowData={historyRow}
									propertyData={propertyData}
									dataSet={dataSet}
									dataSource={dataSource}
								/>;
							}
						}

						return (
							<td key={`history-${historyRow.id || idx}-${col.key}-${j}`} className="history-cell">
								{typeof cellContent === 'string' ? (
									<Highlight text={cellContent} substring={searchString} />
								) : (
									cellContent
								)}
							</td>
						);
					})}
				</tr>
			))}
		</>
	);
}

export default HistoryAccordion;
